import { render, staticRenderFns } from "./OccupationskillsModifiedWidget.vue?vue&type=template&id=c4d7d85c"
import script from "./OccupationskillsModifiedWidget.vue?vue&type=script&lang=js"
export * from "./OccupationskillsModifiedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4d7d85c')) {
      api.createRecord('c4d7d85c', component.options)
    } else {
      api.reload('c4d7d85c', component.options)
    }
    module.hot.accept("./OccupationskillsModifiedWidget.vue?vue&type=template&id=c4d7d85c", function () {
      api.rerender('c4d7d85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/OccupationskillsModifiedWidget.vue"
export default component.exports